/* eslint-disable */
import { useState, useEffect, useContext, useRef, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

import { formatUtcDate } from "helpers/DateCalculation";

import { Link } from "react-router-dom";

//import context
import { GlobalProvider } from "context/GlobalContext";

import ActionLogHeader from "./Header/ActionLogHeader";
import ActionLogBreadCrumb from "./BreadCrumb/ActionLogBreadCrumb";
import ActionLogFilter from "./Filter/ActionLogFilter";

const FIELD_TO_PARAM = {
  fullname: "fullname",
  email: "email",
  module: "module",
  action: "action",
  ipaddress: "ipaddress",
  url: "actionurl",
  systeminfo: "systeminfo",
  actiondateformated: "actiondateformated",
};

const ActionLogList = () => {
  const {
    reloadActionLogList,
    setreloadActionLogList,
    screenHeight,
    filterActionLogDates,
    setfilterActionLogDates,
  } = useContext(GlobalProvider);

  const todayValue = new Date().toISOString().split("T")[0];

  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");
  // without pagination ------------------------------------
  const [actionLogs, setActionLogs] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterTimer = useRef(null);

  /* useState hook to download excel file */
  const [downloadExcel, setDownloadExcel] = useState(false);
  /* hook to get number of records */
  const [records, setRecords] = useState(0);

  /* hook to search */
  const [search, setSearch] = useState("");

  const blockRefSelected = useRef(null); // this will be used to access dom element directly

  /* function for checking record count */
  const checkedRecordCount = (selectCount) => {
    if (blockRefSelected.current) {
      blockRefSelected.current.innerHTML = selectCount;
    }
  };

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return actionLogs.filter((item) => selectedIds.includes(item._id));
  };

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : actionLogs;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "ActionLogs.xlsx");
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "fullname",
        accessorKey: "fullname",
        header: t("User"),
        size: 280,
      },
      {
        id: "email",
        accessorKey: "email",
        header: t("Email"),
        size: 280,
      },
      {
        id: "module",
        accessorKey: "module",
        header: t("Module"),
        size: 300,
      },
      {
        id: "action",
        accessorKey: "action",
        header: t("Action"),
        size: 280,
      },
      {
        id: "ipaddress",
        accessorKey: "ipaddress",
        header: t("Ip Address"),
        size: 300,
      },
      {
        id: "url",
        accessorKey: "url",
        header: t("Url"),
        size: 500,
      },
      {
        id: "systeminfo",
        accessorKey: "systeminfo",
        header: t("System Information"),
        size: 500,
      },
      {
        id: "actiondateformated",
        accessorKey: "actiondateformated",
        header: t("Date"),
        size: 280,
      },
    ],
    [t]
  );

  //function for get all action logs
  const getAllActionLogs = async (currentColumnFilters = columnFilters) => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ACTION_LOGS + `?token=${token}`;

      if (filterActionLogDates && filterActionLogDates !== "") {
        requestUrl += `&filterdates=${filterActionLogDates}`;
      } else {
        requestUrl += `&filterdates=${todayValue}`;
      }

      currentColumnFilters.forEach(({ id, value }) => {
        const param = FIELD_TO_PARAM[id];
        if (param && value?.toString().trim()) {
          requestUrl += `&${param}=${encodeURIComponent(value.toString().trim())}`;
        }
      });

      console.log("action log url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("action logs response ========>>>", response);

      if (response.data) {
        setActionLogs(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  useEffect(() => {
    if (responseReceived === false) {
      getAllActionLogs();
    }
  }, [responseReceived]);

  useEffect(() => {
    if (reloadActionLogList) {
      getAllActionLogs();
      setreloadActionLogList(false);
    }
  }, [reloadActionLogList]);

  useEffect(() => {
    if (filterActionLogDates != "") {
      getAllActionLogs();
    }
  }, [filterActionLogDates]);

  /* set records based on actionLogs */
  useEffect(() => {
    setRecords(actionLogs.length);
  }, [actionLogs]);

  /* column filter — debounced API call */
  useEffect(() => {
    clearTimeout(columnFilterTimer.current);
    columnFilterTimer.current = setTimeout(() => {
      getAllActionLogs(columnFilters);
    }, 500);
  }, [columnFilters]);

  /* sync selected count to DOM ref */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, actionLogs]);

  return (
    <div className="tab-content" id="surveyTabContent">
      <div className="container-fluid px-4">
        <ActionLogBreadCrumb />
        <ActionLogHeader
          setSearch={setSearch}
          setDownloadExcel={setDownloadExcel}
          records={records}
          blockRefSelected={blockRefSelected}
        />

        <ActionLogFilter />

        <div className="table-responsive">
          {/* ========= MaterialReactTable start ======= */}
          <MaterialReactTable
            columns={tableColumns}
            data={actionLogs}
            enableSorting
            enableFilters
            enableGlobalFilter={false}
            manualFiltering
            enableGrouping
            enableColumnOrdering
            enableStickyHeader
            enableRowSelection
            onRowSelectionChange={setRowSelection}
            onColumnFiltersChange={setColumnFilters}
            getRowId={(row) => row._id}
            state={{ rowSelection, columnFilters }}
            muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
            muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
            muiTableBodyProps={{ sx: { overflow: "visible" } }}
            initialState={{
              pagination: { pageSize: 100, pageIndex: 0 },
              showColumnFilters: true,
            }}
          />
          {/* ========= MaterialReactTable end ======= */}
        </div>
      </div>
    </div>
  );
};

export default ActionLogList;
